/*
 * http://jasonwatmore.com/post/2018/10/29/angular-7-user-registration-and-login-example-tutorial
 *
 * The alert component passes alert messages to the template whenever a message is received from the alert service.
 * It does this by subscribing to the alert service's getMessage() method which returns an Observable.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, interval, Subject } from 'rxjs';
import { take, map, takeUntil, filter } from 'rxjs/operators';
import { AlertService } from '@services/alert.service';
import { Alert } from './alert';
import { trigger, style, animate, transition } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';
import { UpdateService } from '@app/_services/update.service';

@Component({
  selector: 'alert',
  templateUrl: 'alert.component.html',
  styleUrls: ['alert.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [style({
        opacity: 0,
        // transform: 'scale(0)'
      }), animate('400ms cubic-bezier(0,.88,.23,1)',
        style({
          opacity: 1,
          // transform: 'scale(1)'
        }))]),
      // transition(':leave', [style({opacity: 1, transform: 'scale(1)'}), animate('400ms cubic-bezier(0,.88,.23,1)',
      //   style({ opacity: 0, transform: 'scale(0)'
      //   }))])
    ]),
  ]
})

export class AlertComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  public message: any;
  public progressValue: number = 0;
  private destroyProgress$ = new Subject<void>();

  public messageGroup: string[];

  constructor(
    private alertService: AlertService,
    private updateService: UpdateService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.subscription.add(this.alertService.getMessage().subscribe((message: Alert) => {
      this.message = message;

      if (message && message.closeAutomatically) {
        this.startCounter(message.closeAutomaticallyTimeInMs ? message.closeAutomaticallyTimeInMs : null);
      }
    }));

    this.subscription.add(this.alertService.messageGroup.subscribe(value => { this.messageGroup = value; }));
  }

  startCounter(customTime?: number) {

    const intervl: number = Math.floor(customTime ? customTime : 6000) / 100;
    this.destroyProgress$.next();
    this.progressValue = 0;

    interval(intervl).pipe(
      take(100),
      map((num) => num + 1),
      filter(num => num % 2 === 0),
      takeUntil(this.destroyProgress$)
    ).subscribe(val => {
      this.progressValue = val;
      if (val === 100) {
        this.close();
      }
    });
  }

  ngOnDestroy() {
    this.destroyProgress$.next();

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  close() {
    this.message = null;
    this.alertService.resetMessageGroup();
  }

  refresh() {
    this.message = null;
    this.alertService.resetMessageGroup();
    location.reload();

  }

  multipleMessages(message: string) {
    return /\r|\n/.test(message) ? true : false;
  }

  // Doing this without hostListener for better performance, since events won't get fired when not visible with ngIf
  keyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}
